import React from 'react'
import Logo from './../../../assets/logo.svg'
import { Link } from 'react-router-dom';
import {
    Navvo
} from './NavWidget.style'
import Cookies from 'js-cookie';
import {Redirect} from "react-router-dom"
// import PickEstateWidget from '../../components/Dashboard/pick_estate_widget';
import PickEstateBtn from '../../components/Dashboard/pick_estate_btn';
import MobileSidebarMenu from '../SidebarWidget/mobileSideBard';




function NavWidge2() {
const accesTokenValue = Cookies.get('userAccessToken');


  return (
    <div>

        {/* {(facilityIdValue=== undefined || facilityIdValue.length ===0) &&
        // <PickEstateWidget/>
        } */}
        { (accesTokenValue === undefined || accesTokenValue.length <=0) &&
            <Redirect to="/" />
        }
        
         <Navvo>
            <div className="nav-wrapper white z-depth-0">
                <Link to="/" className="brand-logo p-16 black-text">
                    {/* Dashboard */}
                    <div className='' style={{
                        marginLeft:"40px"
                    }}>
                        <img src={Logo} alt=''/>
                    </div>
                </Link>
                <div  data-target="mobile-demo" className="sidenav-trigger show-on-small show-on-medium hide-on-large-only">
                    <MobileSidebarMenu/>
                </div>
                <ul className="center ">
                    <PickEstateBtn/>
                </ul>
            </div>
            {/* <div className='show-on-small show-on-medium hide-on-large-only'>
                <PickEstateBtn/>
            </div> */}
        </Navvo>
                    
        
        {/* <ul className="sidenav" id="mobile-demo">
            <li><a href="sass.html">Sass</a></li>
            <li><a href="badges.html">Components</a></li>
            <li><a href="collapsible.html">Javascript</a></li>
            <li><a href="mobile.html">Mobile</a></li>
        </ul> */}

    </div>
  )
}

export default NavWidge2